import {AfterViewInit, ChangeDetectionStrategy, Component, DestroyRef, ElementRef, inject, viewChild} from '@angular/core';
import {BaseRequestComponent} from '../base-request-component';
import {AdaptiveCardRequestService} from './services/adaptive-card-request.service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {RequestStepAdaptiveCardViewModel} from '../../../view-models/request-step-adaptive-card.view-model';
import {StepHeaderComponent} from '@shared/components/step-header/step-header.component';
import {prepareAdaptiveCardDataForTransport, renderAdaptiveCard} from '@shared/utilities/adaptive-card-renderer';
import {ModalService} from '@shared/services/modal.service';
import {ErrorModalComponent} from '@shared/components/error-modal/error-modal.component';
import {STEP_SUBMIT_GENERIC_ERROR} from '@shared/utilities/step-submit-error';

@Component({
    selector: 'app-adaptive-card-request',
    templateUrl: './adaptive-card-request.component.html',
    styleUrls: ['./adaptive-card-request.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [StepHeaderComponent]
})
export class AdaptiveCardRequestComponent extends BaseRequestComponent implements AfterViewInit {

  private readonly destroyRef = inject(DestroyRef);
  private readonly adaptiveCardRequestService = inject(AdaptiveCardRequestService);
  private readonly modalService = inject(ModalService);

  readonly container = viewChild.required<ElementRef>('container');

  ngAfterViewInit(): void {
    const stepDetail = this.step() as RequestStepAdaptiveCardViewModel;

    renderAdaptiveCard(stepDetail, this.container(), this.request().readonly, {
      onBack: () => this.previous(),
      onNextOrFinish: (data) => this.request().readonly ? this.next() : this.save(data),
      onClose: () => this.close()
    });
  }

  private save(adaptiveCardData: Record<string, string>) {
    if (this.processing) {
      return;
    }

    this.processing = true;

    const sanitizedData = prepareAdaptiveCardDataForTransport(adaptiveCardData);

    this.adaptiveCardRequestService.save(this.request().id, this.step().id, sanitizedData).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe({
      next: updatedRequest => {
        this.updateRequest(updatedRequest);
        this.processing = false;
        this.next();
      },
      error: () => {
        this.processing = false;
        this.modalService.openModal(ErrorModalComponent, STEP_SUBMIT_GENERIC_ERROR);
      }
    });
  }
}
